import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { TextAreaField } from 'libs/forms/views/fieldTypes/textArea';

import {
  DescriptionWrapper,
  Description,
  DescriptionInput,
} from 'apps/profile/views/profileDescription.styles';

export const ProfileDescription = observer(({ app, formStore, fieldName }) => {
  if (!app.editing) {
    return (
      <DescriptionWrapper>
        <Description>{app[fieldName]}</Description>
      </DescriptionWrapper>
    );
  }
  return (
    <TextAreaField
      fieldStore={formStore.fieldStores.get(fieldName)}
      editComponent={DescriptionInput}
      validationPosition={{ top: '2px', right: '-25px' }}
      className='lightBorder'
    />
  );
});

ProfileDescription.propTypes = {
  app: PropTypes.object,
  fieldStore: PropTypes.object,
  value: PropTypes.string,
};
